module.exports = __webpack_public_path__ + "static/media/loader.53aede58.gif";